import React from "react";
import { Link } from "react-router-dom";
import { useProfile } from "../hooks/UserHooks";

const Sidebar = () => {
  const { userProfile } = useProfile();

  return (
    <div className="sidebar">
      <Link
        className="active"
        to={"/"}>
        Site
      </Link>
      {userProfile.rank == 2 && <Link to={"/admin/category"}>Categories</Link>}
      {userProfile.rank > 0 && <Link to={"/admin/music"}>Musique</Link>}
      {userProfile.rank == 2 && <Link to={"/admin/users"}>Utilisateurs</Link>}
      {/* <Link to={""}>About</Link> */}
    </div>
  );
};

export default Sidebar;
